/**
 * This file contains constants related to collection names.
 *
 * All constants should be UPPERCASE.
 * All constants should be defined as const rather than let
 * All constants should be in alphabetical order.
 * All constants should be exported so other files can easily use them.
 *
 * In ES6 and onward, semicolons are optional. They have been omitted in this file.
 */

export const ACRYLIC_BLOCK_PRINTS = 'acrylic-block-prints'
export const ACRYLIC_PRINTS = 'acrylic-prints'
export const CANVAS_PHOTO_PRINT = 'canvas-photo-print'
export const CIRCLE_STICKER_PRINTS = 'circle-sticker-prints'
export const COASTER_PRINTS = 'coaster-prints'
export const COASTER_SQUARE_PRINTS = 'coaster-square-prints'
export const COLLAGE_PRINTS = 'collage-prints'
export const CREWNECK_SWEATSHIRT = 'crewneck-sweatshirt'
export const CREWNECK_YOUTH_SWEATSHIRT = 'crewneck-youth-sweatshirt'
export const CUTTING_BOARD_GLASS_PRINTS = 'cutting-board-glass-prints'
export const FLEECE_BLANKET_PRINTS = 'fleece-blanket-prints'
export const FOAM_TILE_PRINTS = 'foam-tile-prints'
export const GLASS_PRINTS = 'glass-prints'
export const HOODIE_SWEATSHIRT = 'hoodie-sweatshirt'
export const HOODIE_YOUTH_SWEATSHIRT = 'hoodie-youth-sweatshirt'
export const MAGNET_PRINTS = 'magnet-prints'
export const METAL_MAGNETS_CIRCLE = 'magnet-metal-circle'
export const METAL_MAGNETS_OVAL = 'magnet-metal-oval'
export const METAL_MAGNETS_RECTANGLE = 'magnet-metal-rectangle'
export const METAL_MAGNETS_SQUARE = 'magnet-metal-square'
export const METAL_PRINTS = 'metal-prints'
export const MOUSEPAD_PRINTS = 'mousepad-prints'
export const MUG_PRINTS = 'mug-prints'
export const ORNAMENT_PRINTS = 'ornament-prints'
export const OVAL_STICKER_PRINTS = 'oval-sticker-prints'
export const PILLOW_PRINTS = 'pillow-prints'
export const PLAQUE_PRINTS = 'plaque-prints'
export const POLO_SHIRT = 'polo-shirt'
export const POLO_WOMENS_SHIRT = 'polo-womens-shirt'
export const POLO_YOUTH_SHIRT = 'polo-youth-shirt'
export const POSTER_PRINTS = 'poster-prints'
export const PUZZLE_PRINTS = 'puzzle-prints'
export const RECTANGLE_STICKER_PRINTS = 'rectangle-sticker-prints'
export const SINGLE_CANVAS_FEATURED_PRODUCTS = 'single-canvas-featured-products'
export const SQUARE_STICKER_PRINTS = 'square-sticker-prints'
export const TOTE_PRINTS = 'tote-prints'
export const TOTE_PRINTS_LARGE = 'tote-prints-large'
export const TRIANGLE_STICKER_PRINTS = 'triangle-sticker-prints'
export const TRIPTYCH_FLOW_PRINTS = 'triptych-flow-prints'
export const TRIPTYCH_PRINTS = 'triptych-prints'
export const TSHIRT_PRINTS = 'tshirt-prints'
export const TSHIRT_WOMENS_PRINTS = 'tshirt-womens'
export const TSHIRT_YOUTH_PRINTS = 'tshirt-youth'
export const WALL_DISPLAY = 'wall-display'
export const WALL_DISPLAY_PRINTS = 'wall-display-prints'
export const WOVEN_BLANKET_PRINTS = 'woven-blanket-prints'
